import { request } from "https";
import React from "react";
import { isMobile } from "react-device-detect";
import { useSearchParams ,useParams } from "react-router-dom";

const MbpAthnCallback = () => {
    const [SearchParams, setSearchParams] = useSearchParams();
    // 페이지 변수 -------------------------------------------------------------------------
	// let apiToken = request.toString;		// 토큰값(암호화)
    let apiCertNum = "";	// 요청번호(암호화)
    const {test} = useParams();
    SearchParams.get("apiToken");
    // console.log(apiToken);
    // Parameter 수신 --------------------------------------------------------------------
    // apiToken = request.getParameter("apiToken");
    // apiCertNum = request.getParameter("certNum");

    // // 파라미터 유효성 검증
    // if( apiToken.length() == 0 ){
    //     out.println("<script> alert('토큰값 비정상');");
    //     return;
    // }
    //     if( apiCertNum.length() == 0 ){
    //     out.println("<script> alert('요청번호 비정상');");
    //     return;
    // }
    return (
        <></>
    )
}

export default MbpAthnCallback;